import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const ErrorLabel = styled.p`
  color: ${({ theme }: { theme: Theme }) => theme.colors.input.error.label};
  font-size: 16px;
  line-height: 140%;
  text-align: ${({ align = 'left' }: { align?: 'left' | 'center' }) => align};
`;
